export class RecentlyViewed {
  static #STORAGE_KEY='viewedProducts';
  static #MAX_PRODUCTS=4;

  static addProduct(productId){
    const normalized=String(productId||'').replace('gid://shopify/Product/','').trim();
    if(!/^\d+$/.test(normalized))return;
    let viewed=this.getProducts().filter((id)=>id!==normalized);
    viewed.unshift(normalized);
    viewed=viewed.slice(0,this.#MAX_PRODUCTS);
    localStorage.setItem(this.#STORAGE_KEY,JSON.stringify(viewed));
  }

  static clearProducts(){localStorage.removeItem(this.#STORAGE_KEY);}

  static getProducts(){
    const raw=JSON.parse(localStorage.getItem(this.#STORAGE_KEY)||'[]');
    const clean=Array.isArray(raw)?raw.map((id)=>String(id||'').replace('gid://shopify/Product/','').trim()).filter((id)=>/^\d+$/.test(id)):[];
    if(JSON.stringify(raw)!==JSON.stringify(clean))localStorage.setItem(this.#STORAGE_KEY,JSON.stringify(clean.slice(0,this.#MAX_PRODUCTS)));
    return clean.slice(0,this.#MAX_PRODUCTS);
  }
}

const trackCurrentProduct=()=>{
  if(!window.location.pathname.startsWith('/products/'))return;
  const component=document.querySelector('product-form-component[data-product-id], product-information[data-product-id], [data-product-id][data-product-url]');
  const productId=component?.getAttribute('data-product-id');
  if(productId)RecentlyViewed.addProduct(productId);
};

if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',trackCurrentProduct,{once:true});
else trackCurrentProduct();
